var map = {
	"./bar-chart.svg": 8730,
	"./category.png": 8408,
	"./crop.png": 2398,
	"./crop.svg": 3756,
	"./diagram.png": 7225,
	"./donate.png": 6341,
	"./hydrograph.svg": 6344,
	"./icons/back-arrow.svg": 6926,
	"./icons/blue-water.svg": 1409,
	"./icons/business.png": 179,
	"./icons/business_disabled.png": 4684,
	"./icons/country.png": 6131,
	"./icons/crop_for_selector.svg": 7819,
	"./icons/domestic-water.svg": 3889,
	"./icons/industry.svg": 7865,
	"./icons/left-bottom-radius.svg": 8283,
	"./icons/left-top-radius.svg": 2241,
	"./icons/location.png": 4552,
	"./icons/location_disabled.png": 7493,
	"./icons/product.png": 3656,
	"./icons/product_disabled.png": 53,
	"./icons/raw-product.png": 9629,
	"./icons/raw-product_disabled.png": 8494,
	"./icons/right-bottom-radius.svg": 7244,
	"./icons/right-top-radius.svg": 4564,
	"./icons/river-basin.png": 6463,
	"./icons/river-basin_disabled.png": 3064,
	"./icons/water-risk.png": 2986,
	"./icons/water-risk_disabled.png": 7135,
	"./icons/world.png": 9361,
	"./icons/world_disabled.png": 7554,
	"./logos/sbtn-logo-yellow.svg": 6317,
	"./map.png": 1704,
	"./map.svg": 8908,
	"./mask1.png": 7251,
	"./mask2.png": 1496,
	"./mask3.png": 2625,
	"./minus.svg": 8682,
	"./pie-chart.svg": 9843,
	"./plus.svg": 4034,
	"./shape.png": 8409,
	"./shape1.png": 4484,
	"./shape1_new.png": 4683,
	"./shape2.png": 6943,
	"./shape2_new.png": 8644,
	"./shape3.png": 1846,
	"./shape3_new.png": 3465,
	"./shape_disabled.png": 1325,
	"./table.svg": 578
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1382;